export const colours = {
	primary: "#1182D4",
	onLight: "#3B413C",
	onDark: "#FFFFFF",
	bg: "#FFFFFF",
	grey1: "#F5F5F5",
	grey2: "#F0F0F0",
	grey3: "#C4C4C4",
	grey4: "#939393",
	grey5: "#535954",
    star: "#F2DB07",
    green:"#24BB71",
    listTile: "#F3FBFF"
};

export default colours;